/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 49a830b3 (Tue Jan 27 16:18:40 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Supervisor
 */
export interface Supervisor {
  /**
   * Unique identifier for a supervisor.
   * @type number
   * @memberof Supervisor
   */
  id: number
  /**
   * The role played by the supervisor of the community.
   * @type string
   * @memberof Supervisor
   */
  role: string
  /**
   * Unique identifier referencing a user containing properties like firstName, lastName, userName, and email.
   * @type number
   * @memberof Supervisor
   */
  userId: number
}

export function SupervisorFromJSON(json: any): Supervisor {
  return SupervisorFromJSONTyped(json, false)
}

export function SupervisorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Supervisor {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    role: json['role'],
    userId: json['userId'],
  }
}

export function SupervisorToJSON(value?: Supervisor | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    role: value.role,
    userId: value.userId,
  }
}
